const sources = {
  api: { id: 'api', name: 'Ruddr API' },
  bamboohr: { id: 'bamboohr', name: 'BambooHR' },
  csv: { id: 'csv', name: 'CSV Import' },
  expensify: { id: 'expensify', name: 'Expensify' },
  harvest: { id: 'harvest', name: 'Harvest Import' },
  hubspot: { id: 'hubspot', name: 'HubSpot' },
  macos: { id: 'macos', name: 'Ruddr MacOS App' },
  mobile: { id: 'mobile', name: 'Ruddr Mobile App' },
  qbo: { id: 'qbo', name: 'QuickBooks Online' },
  rippling: { id: 'rippling', name: 'Rippling' },
  sage: { id: 'sage', name: 'Sage Intacct' },
  slack: { id: 'slack', name: 'Slack' },
  system: { id: 'system', name: 'Ruddr Internal Process' },
  microsoft_teams: { id: 'microsoft_teams', name: 'Microsoft Teams' },
  web: { id: 'web', name: 'Ruddr Web App' },
  xero: { id: 'xero', name: 'Xero' },
};

export default sources;
